function setTextFieldValue(element, value) {
  element.value = value;
}

export { setTextFieldValue as s };
